import styled from 'styled-components'

export const ConnexionScreen = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 0;
`
export const ConnexionStyled = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
`

export const StyledImg = styled.img`
  width: 9rem;
  height: 9rem;
  object-fit: contain;
`
